import React from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import Config from '../../../../../constants/Config';
import './styles.less';
import {isEqual} from 'lodash';

class GoogleMap extends React.Component {
    
    render() {
        return (
            <div className={`hms-map ${this.props.className || ''}`}>
                <Map {...this.props}
                    google={this.props.google}
                    center={this.props.center || undefined}
                    initialCenter={this.props.center || undefined}
                    zoom={this.props.zoom || 15}
                    centerAroundCurrentLocation={true}
                    className={this.props.mapClassName}>
                    {(this.props.markers || []).map((marker, index) => (
                        <Marker key={index} id={index} position={marker} draggable={true} title={marker.title}
                            onDragend={(m, e) => this.handleChangeGgMap(m,e,index)}/>
                    ))}
                </Map>
            </div>
        )
    }
    handleChangeGgMap = (m, e, index) => {
        this.props.onMarkerDrag && this.props.onMarkerDrag(m, e, index)
        this.props.onChangeZoom && this.props.onChangeZoom(m?.map?.zoom);
    }

}
export default GoogleApiWrapper({
    apiKey: Config.GOOGLE_MAPS_API_KEY
})(GoogleMap);